export default "__VITE_ASSET__CzBeclXm__"